import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { ReactComponent as FilterAltOutlinedIcon } from '../../../static/icons/filter.svg';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { Badge, Chip, Grid, Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Tab from '@mui/material/Tab';
import * as React from 'react';
import { getActiveCalls, getCallStatusData, getCallStatusIvrData, getFilters, getWidgetConfig } from '../../../services/api-service';
import { filterTypes, WIDGET_REFRESH_INTERVAL } from '../../../utils/constants';
import FilterDrawer from '../../FilterDrawer/FilterDrawer';
import OZTable from '../../OZTable/OZTable';
import WidgetDownload from '../../Widget-Download/Widget-Download';
import '../CallStatus/CallStatus.css';
import { checkDataAccessFilters, checkRoles, determineFilterType, getUpdatedFilterType, isFilterPresent, secondsToMinSec, secondsToTime } from '../../../utils/util';
import CallStatusProgressBar from './CallStatusProgressBar';
import useChartResize from '../../../hooks/useChartResize';
import { getLastFetchedDetailFromBrowser } from '../../../services/application-service';
import DurationSelector from '../../DurationSelector/DurationSelector';
import { CircularProgress } from '@mui/material';
import useRealTimeDuration from '../../../hooks/useRealTimeDuration';
import { isSubAdmin } from '../../../services/auth-service';


export default function CallStatusIvr(props: any) {
	const { useState, useRef } = React;
	const [isDrawerOpen, setIsDrawerOpen] = useState<boolean | undefined>(false);
	const [callType, setCallType] = React.useState('all');
	const [responseLength, setresponseLength] = useState<Number>(0);
	const downloadContent = useRef<null | any>(null);
	const [callStatus, setCallStatus] = useState<any>({});
	const [rowData, setRowData] = useState<Array<any>>([]);
	const [columnData, setColumnData] = useState<Array<any>>([]);
	const [allowedFilters, setAllowedFilters] = useState<string[]>(['Campaign']);
	const [filterType, setFilterType] = useState<any>(props?.selectedFilters?.filterSection?.id || 1);
	const [filterSection, setFilterSection] = useState<any>(props?.selectedFilters?.filterSection || {});
	const [abandonedCallsSeparate, setAbandonedCallsSeparate] = useState<any>({ outbound: 0, inbound: 0 });
	const [answeredCallsSeparate, setAnsweredCallsSeparate] = useState<any>({ outbound: 0, inbound: 0 });
	const [totalCallsSeparate, setTotalCallsSeparate] = useState<any>({ outbound: 0, inbound: 0 });
	const [lastFetchedTime, setLastFetchedTime] = useState<any>('');
	const [duration, setDuration] = useState<any>();
	const [durationLabel, setDurationLabel] = useState<string>('Today');
	const [loadingCallStatus, setLoadingCallStatus] = useState<boolean>(true);
	const { chartContainerRef, chartDimensions } = useChartResize();
	const { realtime, handleClickRealTime, getDuration } = useRealTimeDuration({ duration });
	const [campaignsListFilter, setCampaignsListFilter] = useState<any>([]);
	const sendAllCampaignByDefault = React.useMemo(() => isSubAdmin(), []);

	const intervalRef = useRef<any>(null);
	const isWidgetDataLoadingRef = useRef<boolean>(false);

	React.useEffect(() => {
		if (sendAllCampaignByDefault) {
			saveCampaignFilter()
		}
	}, [sendAllCampaignByDefault])

	async function saveCampaignFilter() {
		try {
			const apiResponse: any = await getFilters("Campaign", {}, "IVR");
			if (apiResponse && apiResponse?.length) {
				setCampaignsListFilter(apiResponse);
			}
		} catch (error) {
			console.error('Error fetching campaign filters:', error);
		}
	}

	const handleChange = (event: React.SyntheticEvent, newValue: string) => {
		setCallType(newValue);
		setLoadingCallStatus(true);
	};

	const toggleDrawer = (isOpen: boolean) => {
		setIsDrawerOpen(isOpen);
	};

	const handleDownload = (type: string) => {
		console.log(type);
	};

	const handleFilterDelete = (id: Number) => {
		try {
			const newFilter = callStatusFilter.filter((item: any) => item.id !== id);
			setCallStatusFilter(newFilter);
			props?.handleFilterChange?.(newFilter, filterSection, props?.widgetId)
			setLoadingCallStatus(true);
		} catch (error) {
			console.error('Error deleting filter:', error);
			setLoadingCallStatus(false);
		}
	};

	const clearFilter = () => {
		try {
			console.info('Clear all filter.');
			setCallStatusFilter([]);
			props?.handleFilterChange?.([], filterSection, props?.widgetId)
			setLoadingCallStatus(true);
		} catch (error) {
			console.error('Error clearing filter:', error);
			setLoadingCallStatus(false);
		}
	};

	const [callStatusFilter, setCallStatusFilter] = useState<any>(props?.selectedFilters?.filters || []);

	const filterItems = callStatusFilter.map((item: any, index: number) => (
		<Chip key={index} label={item.label} color="primary" variant="outlined" onDelete={() => handleFilterDelete(item.id)} deleteIcon={<CloseOutlinedIcon style={{ fontSize: '12px' }} />} />
	));

	function handleDuration(type: string = '', timeObj: any) {
		if (type) {
			setDurationLabel(type);
			setDuration(timeObj);
			setLoadingCallStatus(true);
		}
	}

	const getCallStatus = async (filters = '0', duration: any) => {
		if (isWidgetDataLoadingRef.current || !duration) {
			console.log('Widget data fetch already in progress, skipping this cycle getCallStatus');
			return;
		};
		isWidgetDataLoadingRef.current = true;
		try {
			// For "Today" duration, always update toTime to current time to ensure real-time data
			let adjustedDuration = getDuration();

			let data: any = await getCallStatusIvrData({
				filters,
				type: getUpdatedFilterType(filterType, 'string'),
				...adjustedDuration
			});
			console.log("Call Status IVR Data:", data);
			data = data?.data[0] || [];
			// let totalValueData = { activeCalls: 0 };
			// const filterKey = structuredClone(filterTypes.find((item: any) => item.id === +filterType) ?? filterTypes[0]);
			// filterKey.label = (filterKey.label === 'Campaign Type' || filterKey.label === 'CampaignType') ? 'Campaign' : filterKey.label;
			// filterKey.value = (filterKey.value === 'Campaign Type' || filterKey.value === 'CampaignType') ? 'Campaign' : filterKey.value;
			// console.log("filterKey", filterKey)
			// const filterValueKey = `${filterKey.value}Name`;
			// const totalValueData = data.find((item: any) => item[filterValueKey] === '0');
			// setTotalCallsSeparate({ outbound: parseInt(totalValueData?.TotalOutboundCalls || 0) || 0, inbound: parseInt(totalValueData?.TotalInboundCalls || 0) || 0 });
			// setAnsweredCallsSeparate({ outbound: parseInt(totalValueData?.TotalOutboundAnsweredCalls || 0) || 0, inbound: parseInt(totalValueData?.TotalInboundAnsweredCalls || 0) || 0 });
			// setAbandonedCallsSeparate({ outbound: parseInt(totalValueData?.TotalOutboundUnAnsweredCalls || 0) || 0, inbound: parseInt(totalValueData?.TotalInboundUnAnsweredCalls || 0) || 0 });
			// if (callStatusFilter.length <= 2) {
			// const historicData = await getCallStatusIvrData({ filters, type: getUpdatedFilterType(filterType, 'string'), callType, dateTypeId: '1', ...adjustedDuration });
			// const totalHistoricValueData = historicData.find((item: any) => item[filterValueKey] === '0');
			// if (totalValueData) {
			// 	totalValueData.averageHandlingTimeTicker = +totalHistoricValueData?.AverageHandlingTime
			// 		? +(((+totalValueData.AverageHandlingTime - +totalHistoricValueData.AverageHandlingTime) / +totalHistoricValueData.AverageHandlingTime) * 100).toFixed(2)
			// 		: 0;
			// 	totalValueData.averageAnswerTimeTicker = +totalHistoricValueData?.AverageAnswerTime
			// 		? +(((+totalValueData.AverageAnswerTime - +totalHistoricValueData.AverageAnswerTime) / +totalHistoricValueData.AverageAnswerTime) * 100).toFixed(2)
			// 		: 0;
			// const activeCalls = await getActiveCalls();
			// totalValueData.activeCalls = activeCalls.activeIvrCalls;
			// }
			setCallStatus(data);
			// } else {
			// const columns = [
			// 	// { name: filterKey.label, key: filterValueKey },
			// 	// { name: 'AHT', key: 'AverageHandlingTime', subTitle: totalValueData.AverageHandlingTime },
			// 	// { name: 'ATT', key: 'AverageTalkTime', subTitle: totalValueData.AverageTalkTime },
			// 	// { name: 'AWT', key: 'AverageWrapupTime', subTitle: totalValueData.AverageWrapupTime },
			// 	// { name: 'Avg. Hold Time', key: 'AverageHoldTime', subTitle: totalValueData.AverageHoldTime },
			// 	// { name: 'Avg. Answer Time', key: 'AverageAnswerTime', subTitle: totalValueData.AverageAnswerTime },
			// 	// { name: 'Active Calls', key: 'TotalCalls', subTitle: totalValueData.TotalCalls },
			// 	// { name: 'Total Answered', key: 'AnsweredCalls', subTitle: totalValueData.AnsweredCalls },
			// 	// { name: 'Total Abandoned', key: 'UnansweredCalls', subTitle: totalValueData.UnansweredCalls }

			// 	{ name: filterKey.label, key: filterValueKey },
			// 	{ name: 'Avg Answer Time', key: 'AvgAnswerDuration' },
			// 	{ name: 'Avg Call Duration', key: 'AvgCallDuration' },
			// 	{ name: 'Active Calls in IVR', key: 'TotalCalls' },
			// 	{ name: 'Total Answered', key: 'ConnectedCalls' },
			// 	{ name: 'Total Abandoned', key: 'AbandonedCalls' },
			// 	{ name: 'Total Calls', key: 'TotalCalls' }
			// ];
			// const actualData = data.filter((item: any) => item[filterValueKey] !== '0');
			// const updatedData = convertDataToTime(actualData);
			// setRowData(updatedData);
			// setColumnData(columns);
			// }
			setLastFetchedTime(getLastFetchedDetailFromBrowser());
		} catch (error) {
			console.error('Error fetching call status:', error);
		} finally {
			isWidgetDataLoadingRef.current = false;
			setLoadingCallStatus(false);
		}
	};

	const timeFormatKeys = ['AverageHandlingTime', 'AverageTalkTime', 'AverageWrapupTime', 'AverageHoldTime', 'AverageAnswerTime']
	function convertDataToTime(data: any[]) {
		return data.map((obj: any) => {
			const newObj: any = {};
			for (const key in obj) {
				if (obj.hasOwnProperty(key) && timeFormatKeys.includes(key)) {
					newObj[key] = secondsToTime(obj[key]);
				} else {
					newObj[key] = obj[key]
				}
			}
			return newObj;
		});
	}

	const handleFilterExistingData = (filteredData: any) => {
		setCallStatusFilter(filteredData);
		props?.handleFilterChange?.(filteredData, filterSection, props?.widgetId);
	};

	const handleApplyFilters = ({ selectedFilters, filterType: newFilterType, filterSection: newfilterSection }: any) => {
		try {
			setCallStatusFilter(selectedFilters);
			setFilterType(newFilterType);
			setFilterSection(newfilterSection);
			props?.handleFilterChange?.(selectedFilters, newfilterSection, props?.widgetId)
			setLoadingCallStatus(true);
			toggleDrawer(false);
		} catch (error) {
			console.error('Error applying filters:', error);
			setLoadingCallStatus(false);
		}
	};

	React.useEffect(() => {
		const fetchWidgetConfig = async () => {
			try {
				if (checkDataAccessFilters()) {
					let widgetConfig = await getWidgetConfig('302', 'widget');
					if (widgetConfig) {
						if (typeof widgetConfig === 'string') {
							widgetConfig = JSON.parse(widgetConfig);
						}
						// Check the condition and set the appropriate filters
						const filters = widgetConfig.data && checkDataAccessFilters()
							? widgetConfig.data
							: widgetConfig.config;

						if (filters) {
							const filtersArray = filters.split(',');
							setAllowedFilters(filtersArray);
							const determinedFilterType = determineFilterType(filtersArray);
							if (determinedFilterType !== undefined) {
								let savedFilter = props?.selectedFilters?.filterSection;
								if (savedFilter && savedFilter?.id !== undefined && isFilterPresent(filtersArray, savedFilter?.value)) {
									setFilterType(savedFilter?.id);
								} else {
									setFilterType(determinedFilterType);
								}

							}
						}
					}
				}
			} catch (error) {
				console.error('Error fetching widget config:', error);
			}
		};
		fetchWidgetConfig();
	}, []);

	React.useEffect(() => {
		// const filterIds = (agentListFilter.length && !(responseLength === agentListFilter.length)) ? agentListFilter.map((item: any) => item.id).join(',') : '0';
		let filterIds = (callStatusFilter.length && !(responseLength === callStatusFilter.length)) ? callStatusFilter.map((item: any) => item.id).join(',') : '0';
		if (sendAllCampaignByDefault && !campaignsListFilter?.length) {
			return;
		}
		if (sendAllCampaignByDefault && campaignsListFilter.length && filterIds === '0') {
			filterIds = campaignsListFilter.map((item: any) => item.Id).join(',');
		}
		getCallStatus(filterIds, duration);
		if (intervalRef.current) {
			clearInterval(intervalRef.current);
		}
		if (realtime) {
			intervalRef.current = setInterval(() => getCallStatus(filterIds, duration), WIDGET_REFRESH_INTERVAL.CALL_STATUS);
		}
		return () => {
			clearInterval(intervalRef.current);
		};
	}, [callStatusFilter, callType, duration, realtime, campaignsListFilter]);


	const widgetCardInnerLabelSX = React.useMemo(
		() => ({ fontSize: "13px", color: "#546881", fontWeight: 500 }),
		[]
	);
	return (
		<Card className="customCard">
			<div className="card-header border-none">
				<div className="card-title">
					Call Status <span className="card-sub-header">&nbsp;(IVR)</span>
					{realtime ? <div className="card-title-badge">Live</div> : ''}
					<span className="last-fetched-time" style={{ marginLeft: '6px' }}>Last updated at {lastFetchedTime} </span>
				</div>
				<div className="card-actions">
					<DurationSelector
						duration={durationLabel}
						handleDuration={handleDuration}
						enableTodayDuration={true}
						showRealTimeToggle={true}
						realtime={realtime}
						handleClickRealTime={handleClickRealTime}
					/>
					<WidgetDownload element={downloadContent} handleDownload={handleDownload} name={'Call Status'}></WidgetDownload>
					<div className="card-icon" onClick={() => toggleDrawer(true)}>
						<Badge badgeContent={callStatusFilter.length} color="primary">
							<FilterAltOutlinedIcon fontSize="small" style={{ color: '#536580' }} />
						</Badge>
					</div>
				</div>
			</div>
			<FilterDrawer campaignType={"IVR"} isOpen={isDrawerOpen} toggleDrawer={toggleDrawer} applyFilters={handleApplyFilters} existingSelectedFilters={callStatusFilter} setResponseLength={setresponseLength} existingFilterCategory={filterType} applyFilterOnExistingData={handleFilterExistingData} disableCampaignGroupSelection={true} allowedFilters={allowedFilters} />
			<Box ref={downloadContent} sx={{ width: '100%', typography: 'body1', height: "100%" }}>
				<TabContext value={callType}>
					{/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
						<TabList onChange={handleChange} className="customTabs">
							<Tab label="All" value="all" />
							<Tab label="Voice" value="voice" />
							<Tab label="Manual" value="manual" />
							<Tab label="Preview" value="preview" />
							<Tab label="Progressive" value="progressive" />
							<Tab label="Predictive" value="predictive" />
						</TabList>
					</Box> */}
					{loadingCallStatus ? <Box sx={{ width: '100%', height: "calc(100% - 42px)", backgroundColor: "#FFFFFF", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						<CircularProgress />
					</Box> :
						<div className="customTabPanel" style={{ height: "calc(100% - 42px)", backgroundColor: "#FFFFFF" }} ref={chartContainerRef}>
							{/* {!checkRoles("ROLE_DATA_ACCESS") &&
								<Grid container spacing={2} height={"100%"} alignItems={"center"}>
									{callStatusFilter.length > 0 && (
										<Grid item xs={12}>
											<div className="filter-outer">
												<div className="filter-container">
													<Stack direction="row" spacing={1}>
														{filterItems}
													</Stack>
												</div>
												<div className="filter-remove" onClick={clearFilter}>
													Remove
												</div>
											</div>
										</Grid>
									)}
									{callStatusFilter.length > 2 ? (
										<OZTable rows={rowData} columns={columnData} noMaxHeight={true} height={Math.floor((chartDimensions.height > 360 ? chartDimensions.height + 10 : chartDimensions.height) - 36)} />
									) : (
										<>
											<Grid item xs={12}>
												<div className="widget-inner-card">
													<Grid container direction="row" justifyContent="space-between" alignItems="center">
														<Grid item xs={5}>
															<div className="widget-values-container">
																<div className="widget-caption">Average Handling Time</div>
																<div className="widget-values">
																	<div className="widget-value">{secondsToMinSec(callStatus.AverageHandlingTime) || '-'}</div>
																	<div className={`widget-value-update ${callStatus.averageHandlingTimeTicker < 0 ? '' : 'red'}`}>
																		{callStatus.averageHandlingTimeTicker < 0 ? (
																			<img src={`${process.env.PUBLIC_URL}/icons/down-green-arrow.svg`} width="11" alt="Average Handling Time"></img>
																		) : (
																			<img src={`${process.env.PUBLIC_URL}/icons/up-red-arrow.svg`} width="11" alt="Average Handling Time"></img>
																		)}{' '}
																		{`${callStatus.averageHandlingTimeTicker || 0}%`}
																	</div>
																</div>
															</div>
														</Grid>
														<Grid item xs={7}>
															<Grid container spacing={2}>
																<Grid item xs={6}>
																	<div className="widget-values-container widget-values-sm">
																		<div className="widget-caption">Avg. Talk Time</div>
																		<div className="widget-values">
																			<div className="widget-value">{secondsToMinSec(callStatus.AverageTalkTime) || '-'}</div>
																		</div>
																	</div>
																</Grid>
																<Grid item xs={6}>
																	<div className="widget-values-container widget-values-sm">
																		<div className="widget-caption">Avg. Hold Time</div>
																		<div className="widget-values">
																			<div className="widget-value">{secondsToMinSec(callStatus.AverageHoldTime) || '-'}</div>
																		</div>
																	</div>
																</Grid>
																<Grid item xs={6}>
																	<div className="widget-values-container widget-values-sm">
																		<div className="widget-caption">Avg. Wrap-up-time</div>
																		<div className="widget-values">
																			<div className="widget-value">{secondsToMinSec(callStatus.AverageWrapupTime) || '-'}</div>
																		</div>
																	</div>
																</Grid>
															</Grid>
														</Grid>
													</Grid>
												</div>
											</Grid>
											<Grid item xs={5}>
												<div className="widget-inner-card">
													<Grid item xs={12}>
														<div className="widget-values-container widget-values-sm">
															<div className="widget-caption">Average Answer Time</div>
															<div className="widget-values">
																<div className="widget-value widget-value-md">{secondsToMinSec(callStatus.AvgAnswerDuration) || '-'}</div>
																<div className={`widget-value-update ${callStatus.averageAnswerTimeTicker < 0 ? '' : 'red'}`}>
																	{callStatus.averageAnswerTimeTicker < 0 ? (
																		<img src={`${process.env.PUBLIC_URL}/icons/down-green-arrow.svg`} width="11" alt="Average Handling Time"></img>
																	) : (
																		<img src={`${process.env.PUBLIC_URL}/icons/up-red-arrow.svg`} width="11" alt="Average Handling Time"></img>
																	)}{' '}
																	{`${callStatus.averageAnswerTimeTicker || 0}%`}
																</div>
															</div>
														</div>
													</Grid>
												</div>
											</Grid>
											<Grid item xs={7}>
												<div className="widget-inner-card">
													<Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="center">
														<Grid item xs={6}>
															<div className="widget-values-container widget-values-sm">
																<div className="widget-caption">Total Calls</div>
																<div className="widget-values">
																	<div className="widget-value">{callStatus.TotalCalls || '-'}</div>
																</div>
															</div>
														</Grid>
														<Grid item xs={6}>
															<div className="widget-values-container widget-values-inline">
																<div className="widget-values-row">
																	<div className="widget-caption">Total Answered</div>
																	<div className="widget-value">{callStatus.AnsweredCalls || '-'}</div>
																</div>
																<div className="widget-values-row">
																	<div className="widget-caption">Total Abandoned</div>
																	<div className="widget-value">{callStatus.UnansweredCalls || '-'}</div>
																</div>
																<div className="widget-values-row">
																	<div className="widget-caption">Active Calls in IVR</div>
																	<div className="widget-value">{callStatus.activeCalls || '0'}</div>
																</div>
															</div>
														</Grid>
													</Grid>
												</div>
											</Grid>
										</>
									)}
								</Grid>
							} */}

							<Grid container spacing={1} height={"100%"} alignItems={"start"}>
								{callStatusFilter.length > 0 && (
									<Grid item xs={12} maxHeight={"46px"}>
										<div className="filter-outer">
											<div className="filter-container">
												<Stack direction="row" spacing={1}>
													{filterItems}
												</Stack>
											</div>
											<div className="filter-remove" onClick={clearFilter}>
												Remove
											</div>
										</div>
									</Grid>
								)}
								<Grid item xs={12}>
									<Grid container direction="column" spacing={2} sx={{ padding: '10px' }}>
										<Grid spacing={1} container item alignItems="center">
											<Grid item xs={4}>
												<Typography sx={widgetCardInnerLabelSX} variant="body1">
													Total Calls
												</Typography>
											</Grid>
											<Grid item xs={5}>
												<div className="bar-container">
													<CallStatusProgressBar data={{ outbound: callStatus?.TotalCalls || 0 }} />
												</div>
											</Grid>
										</Grid>

										<Grid spacing={1} container item alignItems="center">
											<Grid item xs={4}>
												<Typography sx={widgetCardInnerLabelSX} variant="body1">
													Connected Calls
												</Typography>
											</Grid>
											<Grid item xs={5}>
												<div className="bar-container">
													<CallStatusProgressBar data={{ outbound: callStatus?.ConnectedCalls || 0 }} />
												</div>
											</Grid>
											{/* <Grid item xs={2} sx={{ marginLeft: 5 }}>
																<Grid container direction="column" sx={{ flexGrow: 1 }}>
																	<Grid item container alignItems="center">
																		<Grid item>
																			<Grid item sx={{
																				width: 8,
																				height: 8,
																				backgroundColor: '#3296FB',
																				borderRadius: '50%',
																				marginRight: 1,
																			}} />
																		</Grid>
																		<Grid item sx={widgetCardInnerLabelSX}>Inbound</Grid>
																	</Grid>
																	<Grid item container alignItems="center" sx={{ marginTop: 0 }}>
																		<Grid item>
																			<Grid item sx={{
																				width: 8,
																				height: 8,
																				backgroundColor: '#E7AF5B',
																				borderRadius: '50%',
																				marginRight: 1,
																			}} />
																		</Grid>
																		<Grid item sx={widgetCardInnerLabelSX}>Outbound</Grid>
																	</Grid>
																</Grid>
															</Grid> */}
										</Grid>

										<Grid spacing={1} container item alignItems="center">
											<Grid item xs={4}>
												<Typography sx={widgetCardInnerLabelSX} variant="body1">
													Abandoned Calls
												</Typography>
											</Grid>
											<Grid item xs={5}>
												<div className="bar-container">
													<CallStatusProgressBar data={{ outbound: callStatus?.AbandonedCalls || 0 }} />
												</div>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
								<>
									{/* <Grid item xs={12}>
										<div className="widget-inner-card">
											<Grid container direction="row" justifyContent="space-between" alignItems="center">
												<Grid item xs={5}>
													{callType === "all" &&
														<Grid container spacing={2} direction={'column'}>
															{/* <Grid item xs={6}>
																	<div className="widget-values-container">
																		<div className="widget-caption">Average Handling Time</div>
																		<div className="widget-values">
																			<div className="widget-value">{secondsToMinSec(callStatus.AverageHandlingTime) || '-'}</div>
																			<div className={`widget-value-update ${callStatus.averageHandlingTimeTicker < 0 ? '' : 'red'}`}>
																				{callStatus.averageHandlingTimeTicker < 0 ? (
																					<img src={`${process.env.PUBLIC_URL}/icons/down-green-arrow.svg`} width="11" alt="Average Handling Time"></img>
																				) : (
																					<img src={`${process.env.PUBLIC_URL}/icons/up-red-arrow.svg`} width="11" alt="Average Handling Time"></img>
																				)}{' '}
																				{`${callStatus.averageHandlingTimeTicker || 0}%`}
																			</div>
																		</div>
																	</div>
																</Grid> 
															<Grid item xs={6}>
																<div className="widget-values-container">
																	<div className="widget-caption">
																		<img
																			style={{ marginTop: '0px', paddingRight: '5px' }}
																			src={`${process.env.PUBLIC_URL}/icons/GreenDotIcon.svg`}
																			alt="edit"
																		>
																		</img>
																		Active Calls in IVR
																	</div>
																	<div className="widget-values">
																		<div className="widget-value" style={{ marginLeft: '15px' }}>{callStatus.activeCalls || '0'}</div>
																	</div>
																</div>
															</Grid> 
														</Grid>
													}
												 {callType !== "all" &&
															<div className="widget-values-container">
																<div className="widget-caption">Average Handling Time</div>
																<div className="widget-values">
																	<div className="widget-value">{secondsToMinSec(callStatus.AverageHandlingTime) || '-'}</div>
																	<div className={`widget-value-update ${callStatus.averageHandlingTimeTicker < 0 ? '' : 'red'}`}>
																		{callStatus.averageHandlingTimeTicker < 0 ? (
																			<img src={`${process.env.PUBLIC_URL}/icons/down-green-arrow.svg`} width="11" alt="Average Handling Time"></img>
																		) : (
																			<img src={`${process.env.PUBLIC_URL}/icons/up-red-arrow.svg`} width="11" alt="Average Handling Time"></img>
																		)}{' '}
																		{`${callStatus.averageHandlingTimeTicker || 0}%`}
																	</div>
																</div>
															</div>
														}
												</Grid>
												<Grid item xs={7}>
													<Grid container spacing={2}>
														<Grid item xs={6}>
															<div className="widget-values-container widget-values-sm">
																<div className="widget-caption">Avg. Call Time</div>
																<div className="widget-values">
																	<div className="widget-value">{secondsToMinSec(callStatus.AvgCallDuration) || '-'}</div>
																</div>
															</div>
														</Grid>
														{/* <Grid item xs={6}>
																<div className="widget-values-container widget-values-sm">
																	<div className="widget-caption">Avg. Hold Time</div>
																	<div className="widget-values">
																		<div className="widget-value">{secondsToMinSec(callStatus.AverageHoldTime) || '-'}</div>
																	</div>
																</div>
															</Grid>
														<Grid item xs={6}>
																<div className="widget-values-container widget-values-sm">
																	<div className="widget-caption">Avg. Wrap-up-time</div>
																	<div className="widget-values">
																		<div className="widget-value">{secondsToMinSec(callStatus.AverageWrapupTime) || '-'}</div>
																	</div>
																</div>
															</Grid> 
														{callType === "all" &&
															<Grid item xs={6}>
																<div className="widget-values-container widget-values-sm">
																	<div className="widget-caption">Average Answer Time</div>
																	<div className="widget-values">
																		<div className="widget-value">{secondsToMinSec(callStatus.AvgAnswerDuration) || '-'}</div>
																	</div>
																</div>
															</Grid>
														}
													</Grid>
												</Grid>
											</Grid>
										</div>
									</Grid> */}

									{/*::::::::::::::::::::::: new implementation::::::::::::::::::::::: */}

									{/* {callType === "all" && */}

									{/* } */}

									{/*::::::::::::::::::::::: new implementation::::::::::::::::::::::: */}
									{/* {callType !== 'all' &&
												<>
													<Grid item xs={5}>
														<div className="widget-inner-card">
															<Grid item xs={12}>
																<div className="widget-values-container widget-values-sm">
																	<div className="widget-caption">Average Answer Time</div>
																	<div className="widget-values">
																		<div className="widget-value widget-value-md">{secondsToMinSec(callStatus.AverageAnswerTime) || '-'}</div>
																		<div className={`widget-value-update ${callStatus.averageAnswerTimeTicker < 0 ? '' : 'red'}`}>
																			{callStatus.averageAnswerTimeTicker < 0 ? (
																				<img src={`${process.env.PUBLIC_URL}/icons/down-green-arrow.svg`} width="11" alt="Average Handling Time"></img>
																			) : (
																				<img src={`${process.env.PUBLIC_URL}/icons/up-red-arrow.svg`} width="11" alt="Average Handling Time"></img>
																			)}{' '}
																			{`${callStatus.averageAnswerTimeTicker || 0}%`}
																		</div>
																	</div>
																</div>
															</Grid>
														</div>
													</Grid>
													<Grid item xs={7}>
														<div className="widget-inner-card">
															<Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="center">
																<Grid item xs={6}>
																	<div className="widget-values-container widget-values-sm">
																		<div className="widget-caption">Total Calls</div>
																		<div className="widget-values">
																			<div className="widget-value">{callStatus.TotalCalls || '-'}</div>
																		</div>
																	</div>
																</Grid>
																<Grid item xs={6}>
																	<div className="widget-values-container widget-values-inline">
																		<div className="widget-values-row">
																			<div className="widget-caption">Total Answered</div>
																			<div className="widget-value">{callStatus.ConnectedCalls || '-'}</div>
																		</div>
																		<div className="widget-values-row">
																			<div className="widget-caption">Total Abandoned</div>
																			<div className="widget-value">{callStatus.AbandonedCalls || '-'}</div>
																		</div>
																		<div className="widget-values-row">
																			<div className="widget-caption">Active Calls in IVR</div>
																			<div className="widget-value">{callStatus.activeCalls || '0'}</div>
																		</div>
																	</div>
																</Grid>
															</Grid>
														</div>
													</Grid>
												</>
											} */}
								</>

							</Grid>
						</div>}
				</TabContext>
			</Box>
		</Card>
	);
}
